<template>
  <div class="filterItemTagContainer" tabindex="-1" :class="{ selectedTagBack: selectedTag }">
    <div class="backButtonContainer ml-4">
      <c-back-button
        v-if="active"
        @click="onBackButtonClicked; onTagSelected(); resetFocus()"
        @keyup.enter="onBackButtonClicked; onTagSelected(); resetFocus()"
        @keyup.space="onBackButtonClicked; onTagSelected(); resetFocus()"
        tabindex="-1"
        :aria-label="$t('ui.seeAllFilterOptions')"
      ></c-back-button>
    </div>
    <div
      class="nav-vertical__item flex-wrap cursor-pointer py-0 text-container-tag"
      :class="[selectedTag ? 'idontlooklikealink' : '']"
      @click.once="onTagSelected(); resetFocus()"
      @keyup.enter="onTagSelected(); resetFocus()"
      @keyup.space="onTagSelected(); resetFocus()"
      :key="wasClicked"
    >
      <button
        class="filter-btn px-2"
        :class="[isFirstTag, selectedTag ? 'idontlooklikealink activeTag' : '']"
        tabindex="0"
        ref="filterItemTagSelector"
        @click.once="onTagSelected(); resetFocus()"
        @keyup.enter="onTagSelected(); resetFocus()"
        @keyup.space="onTagSelected(); resetFocus()"
        :key="wasClicked"
      >
        <div role="status" v-if="active">
          Selection will de-select subcategory and move focus back to the selected category.
        </div>
        <span> 
          <span tabindex="-1" class = visuallyhidden> Health condition subcategory:
          </span>
          {{text}}
          <span tabindex="-1" class= visuallyhidden> {{selectedTag ? 'selected' : 'collapsed'}},
          {{count}} studies
          </span>
        </span>
      </button>
      <span tabindex="-1" ml-1 v-if="count" aria-hidden="true">({{ count }})</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    ariaLabel: String,
    count: [Number, String],
    focus: Boolean,
    id: [Number, String],
    isFirstTag: Boolean,
    text: { required: true, type: String },
    value: { required: true, type: [Number, String, Boolean] },
  },
  computed: {
    selectedTag() {
      return this.$store.getters['search/selectedTag']
    },
    wasClicked() {
      return this.$store.getters['search/wasClicked']
    },
  },
   mounted() {
    this.resetFocus();
  },
  methods: {
    onBackButtonClicked() {
      this.$emit('reset-tag')
    },
    onTagSelected() {
      const { getActiveCategoryFromTag, selectedCategory, selectedTag } = this
      if(!selectedTag)
      this.$emit('tag-selected', this.id)
    },
    resetFocus() {
       this.$nextTick(() => {
         try{
        document.getElementsByClassName("activeTag")[0].focus();
         }
         catch(err){
           
         }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.filterItemTagContainer,
.filterItemTagContainer li {
  width: 100%;
}
.selectedTagBack {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  .text-container-tag {
    display: flex;
    width: 100%;

    padding-right: 0 !important;
  }
}
.nav-vertical__item {
  padding-right: 0 !important;
}
</style>
